import { useEffect } from "react";
import { Layout } from "@/components/Layout";

export default function About() {
  useEffect(() => { document.title = "About — Xurray Journal & Xurray Mart"; }, []);
  return (
    <Layout hideAd>
      <main className="max-w-3xl mx-auto px-4 py-12 font-serif">
        <h1 className="font-display font-bold text-4xl mb-6">About Xurray</h1>
        <p className="mb-4 leading-relaxed text-[17px]">Xurray Mart is a multi-vendor marketplace dedicated to connecting Europe with authentic African products — food, fashion, beauty, and handmade crafts — sourced directly from verified sellers. <strong>Xurray Journal</strong> is our editorial home, where we share original stories, recipes, and guides that celebrate the richness of African culture and help our community shop and sell with confidence.</p>
        <p className="mb-4 leading-relaxed text-[17px]">Our mission is simple: make it easy, safe, and joyful to discover genuine African goods across Europe, while giving talented sellers a trusted platform to reach new customers.</p>
        <h2 className="font-display font-bold text-2xl mt-8 mb-3">What we value</h2>
        <ul className="list-disc pl-6 space-y-2 leading-relaxed text-[17px]">
          <li><strong>Authenticity</strong> — real products with real provenance.</li>
          <li><strong>Trust</strong> — verified sellers, secure payments, honest reviews.</li>
          <li><strong>Community</strong> — supporting African entrepreneurs and the diaspora.</li>
        </ul>
        <p className="mt-6 leading-relaxed text-[17px]">All articles in Xurray Journal are written originally by our editorial team. Images are used as royalty-free placeholders or with permission.</p>
      </main>
    </Layout>
  );
}
